import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CardBackgroundUpdateService } from '../card/card-background-update.service';
import { GraphicCardData } from '../device-model/model/graphic-card-data';
import { GraphicBehaviorIconCreator } from '../display-info-icon/graphic-behavior-icon-creator';
import { GraphicBehaviorType } from '../shared/models/graphic-behavior-type.enum';
import { IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

@Component({
    encapsulation: ViewEncapsulation.None, // has styles in common.scss, TODO
    selector: 'dl-card-list-item',
    templateUrl: './card-list-item.component.html',
    styleUrls: ['./card-list-item.component.scss']
})
export class CardListItemComponent {
    @Input() public item: ICardDataViewModel;
    @Input() public hideValue: boolean;
    @Input() public heating: boolean;
    @Input() public cooling: boolean;

    public displayIcon: IDisplayInfoIcon;

    constructor(private cardBackgroundChangeService: CardBackgroundUpdateService) {
    }

    public ngOnInit() {
        this.displayIcon = new GraphicBehaviorIconCreator(this.cardBackgroundChangeService).createGraphicBehavior(this.item);
    }

    public isGauge(): boolean {
        return this.item.graphicBehavior === GraphicBehaviorType.GAUGE;
    }

    public getGauge() {
        return this.item as GraphicCardData;
    }

    public getValue() {
        if (!this.item.isGraphicBehavior) {
            return this.item.displayValue || this.item.value;
        }
        return this.displayIcon ? this.displayIcon.getValue() : '';
    }

    public getUnits() {
        if (!this.displayIcon) {
            return '';
        }
        if (!this.item.isGraphicBehavior) {
            return ((this.item && this.item.numberSensorInputMap) ? this.item.numberSensorInputMap.units : '');
        }
        return this.displayIcon.getUnits ? this.displayIcon.getUnits() : '';
    }

    public getTitle() {
        return this.item.name;
    }

    public getSubtitle() {
        let subtitle = '';
        if (this.item && this.item.categories) {
            this.item.categories.forEach(c => {
                subtitle = subtitle ? subtitle + '/' + c : c;
            });
        }
        return subtitle;
    }
}
